const withdrawIntentDictPT = {
  paypalEmail: "Insira o e-mail do PayPal abaixo",
  amountWithdrawn: "Valor sacado da carteira",
  amountDeposited: "Valor depositado no PayPal",
  withdrawFee: "taxa de saque",
  paypalFee: "PayPal aplicará uma taxa de",
  onTop: "sobre o valor transferido",
  requestWithdraw: "Solicitar saque",
  amountWithdrawnSuccessfully: "Valor sacado com sucesso!",
  invalidemail: "e-mail inválido",
  withdrawRequests: "Solicitações de saque",
  requestDate: "Data da solicitação",
  processDate: "Data do processamento",
  processing: "Processando",
  amountToDeposit: "Valor para depositar",
  amountRequested: "Valor solicitado",
  processRequest: "Processar solicitação",
  process: "Processar",
  withdrawProcessedSuccessfully: "Solicitação de saque processada com sucesso!",
  withdrawWith: "Sacar com",
  bank: "Banco",
  bankName: "Nome do banco",
  bankAccountNumber: "Número da conta bancária",
  accountOwner: "Nome do titular da conta",
  allFieldsRequired: "Todos os campos são obrigatórios",
  previousBankDataFound: "Dados bancários anteriores encontrados:",
  previousPaypalEmailsFound: "E-mails do PayPal anteriores encontrados:",
  clickToUseOrTypeNew: "Clique para usar ou digite um novo",
  cashbackForBuyer: "Cashback para o comprador",
  cashbackToBuyersSponsor: "Cashback para o patrocinador do comprador",
  cashbackToSellersSponsor: "Cashback para o patrocinador do vendedor",
  amountToBeReceived: "Valor a ser recebido",
  withdrawalRequestsPageTitle: "Solicitações de saques",
  withdrawalRequestsSubtitle: "Histórico de solicitações de saques realizadas.",
  account: "Conta",
  amountToTransfer: "Valor a transferir",
  fee: "Taxa",
  noWithdrawalRequests: "Nenhuma solicitação de saque ainda.",
};

export default withdrawIntentDictPT;
